import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { TrackerImportPage } from "../components/migrations/TrackerImportPage";
import { ToWorkspaces } from "../components/workspaces/ToWorkspaces";
import { ApiError } from "../lib/api";
import { workspaceSlug } from "../lib/hosts";
import { useWorkspace } from "../lib/workspaces";
import { AdministratorsOnly } from "../components/ui/states";
import { strings } from "../lib/strings";

/** The import open, by its id in the address, so a reload or a link comes back to it. */
const importSearchSchema = z.object({ id: z.string().max(40).optional().catch(undefined) });

/** Imports from Jira Cloud and Linear (BUILD_SPEC §19.2, §19.3), for the workspace's Administrators. */
function TrackerImportRoute() {
  const slug = workspaceSlug();
  const view = useWorkspace(slug);
  const search = useSearch({ from: "/admin/settings/import" });
  const navigate = useNavigate();
  if (view.isLoading) return null;
  if (view.error instanceof ApiError || !view.data) return <ToWorkspaces />;
  if (view.data.role !== "administrator") return <AdministratorsOnly what={strings.states.adminPages.trackerImport} />;
  return (
    <TrackerImportPage
      slug={slug}
      openId={search.id}
      onOpen={(id) => void navigate({ to: "/admin/settings/import", search: { id } })}
    />
  );
}

export const Route = createFileRoute("/admin/settings/import")({
  validateSearch: importSearchSchema,
  component: TrackerImportRoute,
});
